<template>
  <a @click="triggerAction">
    <MIcon name="search-plus" class="action-menu-icon" />
    <span class="ml-1 action-menu-text">
      {{ $t('scan_now') }}
    </span>
    <FlotoConfirmModal
      :open="showModal"
      prevent-auto-close-on-confirm
      :processing="processing"
      @hide="showModal = false"
      @confirm="handleConfirmAction"
    >
      <template v-slot:icon>
        <MIcon name="search-plus" class="w-full text-primary" size="2x" />
      </template>
      <template v-slot:message>
        {{
          $t('confirm_scan_now', {
            resource: $tc(moduleName),
          })
        }}
      </template>
    </FlotoConfirmModal>
    <FlotoDrawer :open="showNetworkSelectionDrawer" @hide="hideDrawer">
      <template v-slot:title> {{ $t('add') }} {{ $tc('network') }} </template>
      <MAlert :closable="false" class="my-2" banner type="warning">
        <div>
          {{ $t('please_select_to_continue', { resource: $tc('network') }) }}
        </div>
      </MAlert>

      <NetworkSelectionList
        selectable
        searchable
        @selection-change="setSelectedNetwork"
      />
      <template v-slot:actions="{ hide }">
        <MButton
          :disabled="selectedNetworks.length === 0"
          outline
          class="mr-2"
          :loading="networkProcessing"
          @click="handleAddNetworks"
        >
          {{ $t('add') }} {{ $tc('network') }}
        </MButton>
        <MButton variant="default" @click="hide">
          {{ $t('cancel') }}
        </MButton>
      </template>
    </FlotoDrawer>
  </a>
</template>

<script>
import { successToast, errorToast } from '@motadata/ui'
import { scanNowApi } from '@modules/asset/asset-api'
import NetworkSelectionList from '@components/item-selection-list/network-list'
export default {
  name: 'ScanNow',
  components: { NetworkSelectionList },
  props: {
    moduleName: { type: String, required: true },
    resourceId: { type: Number, required: true },
    updateApi: { type: Function, required: true },
  },
  data() {
    return {
      showModal: false,
      processing: false,
      showNetworkSelectionDrawer: false,
      selectedNetworks: [],
      networkProcessing: false,
    }
  },
  methods: {
    handleAddNetworks() {
      const networkId = this.selectedNetworks.map((i) => i.id)[0]
      this.updateApi({ networkId }).then(() => {
        this.handleConfirmAction()
      })
    },
    setSelectedNetwork(networks) {
      this.selectedNetworks = networks
    },
    hideDrawer() {
      this.selectedNetworks = []
      this.showNetworkSelectionDrawer = false
    },
    handleConfirmAction() {
      this.$emit('done')
      scanNowApi(this.resourceId)
        .then((response) => {
          if (response.networkError) {
            this.showModal = false
            this.showNetworkSelectionDrawer = true
          } else {
            this.showModal = false
            this.showNetworkSelectionDrawer = false
            successToast(this.$tc('scan_submitted_successfully'))
          }
        })
        .catch((e) => {
          this.showModal = false
          this.showNetworkSelectionDrawer = false
          errorToast(((e.response || {}).data || {}).userMessage)
        })
    },
    triggerAction() {
      this.$emit('trigger')
      // show modal after dropdown is hide
      setTimeout(() => {
        this.showModal = true
        this.showNetworkSelectionDrawer = false
      }, 400)
    },
  },
}
</script>
